import React, { useMemo } from 'react';
import { useMaestroContext } from '../context/MaestroContext';
import { empresaEstaEmRisco } from '../utils/empresaStatus';
import { formatarData } from '../utils/formatters';
import Card from './Card';

/** Componente consolidado da seção 12 do épico — sempre visível no Cockpit, independente da visão ativa. */
const SaudeFechamento: React.FC = () => {
  const { cicloAtivo, empresasEscopo, atividades, pontuacoes, dependencias, produtosIntegrados } = useMaestroContext();

  const areasNoPrazo = pontuacoes.filter(p => p.classificacao === 'EXCELENCIA' || p.classificacao === 'ALTO_DESEMPENHO').length;
  const areasEmAtencao = pontuacoes.filter(p => p.classificacao === 'BOM_DESEMPENHO' || p.classificacao === 'EM_EVOLUCAO').length;
  const areasEmRisco = pontuacoes.filter(p => p.classificacao === 'REQUER_ATENCAO').length;

  const empresasEmRisco = useMemo(
    () => empresasEscopo.filter(e => empresaEstaEmRisco(e, atividades, cicloAtivo.progressoEsperado)).length,
    [empresasEscopo, atividades, cicloAtivo.progressoEsperado]
  );
  const empresasNoPrazo = empresasEscopo.length - empresasEmRisco;

  const dependenciasPendentes = dependencias.length;
  const produtosComPendencia = produtosIntegrados.filter(p => {
    if (p.tipo === 'MOTOR_CONCILIACAO') return p.contasPendentes > 0 || p.contasComDivergencia > 0;
    if (p.tipo === 'MAPA_RESULTADOS') return p.contasPendentes > 0 || p.contasComDivergencia > 0;
    if (p.tipo === 'REVISOR_CONTABIL') return p.erros > 0 || p.alertas > 0;
    return p.itensNaFila > 0;
  }).length;

  const tendencia = cicloAtivo.desvio < 0 ? 'Abaixo do planejado' : cicloAtivo.desvio > 0 ? 'Acima do planejado' : 'Em linha com o planejado';

  return (
    <Card title='Saúde do Fechamento' subtitle='Panorama consolidado do ciclo, independente da visão selecionada.'>
      <div className='mc-saude'>
        <div className='mc-saude__percentuais'>
          <div><span>Planejado</span><strong>{cicloAtivo.progressoEsperado}%</strong></div>
          <div><span>Realizado</span><strong>{cicloAtivo.progressoRealizado}%</strong></div>
          <div><span>Desvio</span><strong className={cicloAtivo.desvio < 0 ? 'mc-texto-danger' : 'mc-texto-success'}>{cicloAtivo.desvio > 0 ? '+' : ''}{cicloAtivo.desvio}%</strong></div>
          <div><span>Tendência</span><strong>{tendencia}</strong></div>
        </div>
        <div className='mc-progress mc-progress--grande'>
          <div className='mc-progress__track'><div style={{ width: `${cicloAtivo.progressoRealizado}%` }} /></div>
        </div>
        <div className='mc-saude__grade'>
          <div><span>Áreas no prazo</span><strong className='mc-texto-success'>{areasNoPrazo}</strong></div>
          <div><span>Áreas em atenção</span><strong className='mc-texto-warning'>{areasEmAtencao}</strong></div>
          <div><span>Áreas em risco</span><strong className='mc-texto-danger'>{areasEmRisco}</strong></div>
          <div><span>Empresas no prazo</span><strong className='mc-texto-success'>{empresasNoPrazo}</strong></div>
          <div><span>Empresas em risco</span><strong className='mc-texto-danger'>{empresasEmRisco}</strong></div>
          <div><span>Dependências pendentes</span><strong>{dependenciasPendentes}</strong></div>
          <div><span>Produtos com pendências</span><strong>{produtosComPendencia}</strong></div>
          <div><span>Previsão final</span><strong>{formatarData(cicloAtivo.previsaoConclusao)}</strong></div>
        </div>
      </div>
    </Card>
  );
};

export default SaudeFechamento;
